export const DATE_FORMAT = "YYYY/MM/DD";
export const DATE_TIME_FORMAT_WITH_SECONDS = "YYYY/MM/DD HH:mm:ss";
export const DATE_TIME_FORMAT = "YYYY/MM/DD HH:mm";
export const MONTH_FORMAT = "MM";
export const YEAR_MONTH_STR_FORMAT = "YYYY年MM月";
export const DATE_NOT_TIMEZONE_FORMAT = "YYYY-MM-DD";
export const COMPACT_DATE_FORMAT = "YYYYMMDD";
